import WKSDK, {
  Channel,
  ChannelTypeGroup,
  ConnectStatus,
  ConversationAction,
} from "wukongimjssdk";
import store from "@/store/index.js";

const sortConversations = (conversations) => {
  let newConversations = conversations;
  if (!newConversations) {
    newConversations = store.state.conversationWraps;
  }
  if (!newConversations || newConversations.length <= 0) {
    return [];
  }
  let sortAfter = newConversations.sort((a, b) => {
    let aScore = a.timestamp;
    let bScore = b.timestamp;
    if (a.extra?.top === 1) {
      aScore += 1000000000000;
    }
    if (b.extra?.top === 1) {
      bScore += 1000000000000;
    }
    return bScore - aScore;
  });
  return sortAfter;
};
// 监听链接
const connectStatusListener = async (status, reasonCode) => {
  if (status === ConnectStatus.Connected) {
    console.log("连接成功");
  } else if (status === ConnectStatus.ConnectKick) {
    console.log("被踢--->", reasonCode);
    // WKApp.shared.logout();
  } else if (reasonCode == 2) {
    // 认证失败！
    console.log("认证失败！");
    // WKApp.shared.logout();
  } else if (status === ConnectStatus.Disconnect) {
    // if (this.addrUsed && this.wsaddrs.length > 1) {
    //   const oldwsAddr = this.wsaddrs[0];
    //   this.wsaddrs.splice(0, 1);
    //   this.wsaddrs.push(oldwsAddr);
    //   this.addrUsed = false;
    console.log("连接失败！切换地址->");
    // }
  }
};
// 监听最近会话列表的变化
const conversationListener = (conversation, action) => {
  console.log("监听会话列表", conversation);
  const channelInfo = WKSDK.shared().channelManager.getChannelInfo(
    conversation.channel,
  );
  if (!channelInfo) {
    WKSDK.shared().channelManager.fetchChannelInfo(conversation.channel);
  }
  if (action === ConversationAction.add) {
    console.log("监听会话列表", "增加");
    store.state.conversationWraps = [
      conversation,
      ...(store.state.conversationWraps || []),
    ];
  } else if (action === ConversationAction.update) {
    console.log("监听会话列表", "更新");
    const index = store.state.conversationWraps?.findIndex(
      (item) =>
        item.channel.channelID === conversation.channel.channelID &&
        item.channel.channelType === conversation.channel.channelType,
    );
    if (index !== undefined && index >= 0) {
      const newArray = [...store.state.conversationWraps];
      newArray[index] = conversation;
      store.state.conversationWraps = sortConversations(newArray);
    }
  } else if (action === ConversationAction.remove) {
    console.log("监听会话列表", "删除");
    const index = store.state.conversationWraps?.findIndex(
      (item) =>
        item.channel.channelID === conversation.channel.channelID &&
        item.channel.channelType === conversation.channel.channelType,
    );
    if (index && index >= 0) {
      store.state.conversationWraps?.splice(index, 1);
    }
  }

  syncAllUnreadCount();
};

// 监听cmd消息
const cmdListener = (message) => {
  console.log("收到CMD：", message);
  const cmdContent = message.content;
  const param = cmdContent.param;
  if (cmdContent.cmd === "channelUpdate") {
    // 频道信息更新
    WKSDK.shared().channelManager.fetchChannelInfo(
      new Channel(param.channel_id, param.channel_type),
    );
  } else if (cmdContent.cmd === "unreadClear") {
    const channel = new Channel(param.channel_id, param.channel_type);
    const conversation = WKSDK.shared().conversationManager.findConversation(
      channel,
    );
    let unread = 0;
    if (param.unread > 0) {
      unread = param.unread;
    }
    if (conversation) {
      conversation.unread = unread;
      WKSDK.shared().conversationManager.notifyConversationListeners(
        conversation,
        ConversationAction.update,
      );
    }
    // const clearChannel = new Channel(cmdContent.param.channelID, cmdContent.param.channelType)
    // clearConversationUnread(clearChannel)
  } else if (cmdContent.cmd === "conversationDeleted") {
    // 最近会话删除
    const channel = new Channel(param.channel_id, param.channel_type);
    WKSDK.shared().conversationManager.removeConversation(channel);
  } else if (cmdContent.cmd === "memberUpdate") {
    // 成员更新
    const channel = new Channel(cmdContent.param.group_no, ChannelTypeGroup);
    WKSDK.shared().channelManager.syncSubscribes(channel);
  } else if (cmdContent.cmd === "syncConversationExtra") {
    // 同步最近会话扩展
    WKSDK.shared().conversationManager.syncExtra();
  } else if (cmdContent.cmd === "syncReminders") {
    // 同步提醒项
    WKSDK.shared().reminderManager.sync();
  } else if (cmdContent.cmd === "messageRevoke") {
    // 消息撤回
    const channel = message.channel;
    const messageID = param.message_id;
    let conversation = WKSDK.shared().conversationManager.findConversation(
      channel,
    );
    if (
      conversation &&
      conversation.lastMessage &&
      conversation.lastMessage?.messageID === messageID
    ) {
      conversation.lastMessage.remoteExtra.revoke = true;
      conversation.lastMessage.remoteExtra.revoker = message.fromUID;
      WKSDK.shared().conversationManager.notifyConversationListeners(
        conversation,
        ConversationAction.update,
      );
    }
  }
};

// 监听频道变化
const channelInfoListener = (channelInfo) => {
  console.log("监听频道变化", channelInfo);
  store.state.conversationWraps = [...(store.state.conversationWraps || [])]; // 强制刷新
};

// 同步最近会话列表
const getConversations = async () => {
  const remoteConversations = await WKSDK.shared().conversationManager.sync(); // 同步最近会话列表
  console.log("同步最近会话列表", remoteConversations);
  if (remoteConversations && remoteConversations.length > 0) {
    store.state.conversationWraps = sortConversations(remoteConversations);
  } else {
    store.state.conversationWraps = [];
  }

  syncAllUnreadCount();
};

const syncAllUnreadCount = () => {
  const unreadCount = WKSDK.shared().conversationManager.getAllUnreadCount();
  store.state.unread = unreadCount;
};

const initIm = (token, uid) => {
  console.log("链接im");
  store.state.imtoken = token;
  store.state.imuid = uid;

  WKSDK.shared().config.addr = "wss://wss.5535.cn/";
  // 认证信息
  WKSDK.shared().config.uid = uid; // 用户uid（需要在悟空通讯端注册过）
  WKSDK.shared().config.token = token; // 用户token （需要在悟空通讯端注册过）

  setTimeout(() => {
    // 连接
    WKSDK.shared().connectManager.connect();

    getConversations();
    // 连接状态监听
    WKSDK.shared().connectManager.addConnectStatusListener(
      connectStatusListener,
    );
    // 监听最近会话列表的变化
    WKSDK.shared().conversationManager.addConversationListener(
      conversationListener,
    );
    // 监听频道信息变化
    WKSDK.shared().channelManager.addListener(channelInfoListener);
    // 监听cmd消息
    WKSDK.shared().chatManager.addCMDListener(cmdListener);
  }, 50);
};

const unInitIm = () => {
  // 取消连接状态监听
  WKSDK.shared().connectManager.removeConnectStatusListener(
    connectStatusListener,
  );
  // 取消监听最近会话列表的变化
  WKSDK.shared().conversationManager.removeConversationListener(
    conversationListener,
  );
  // 取消监听频道信息变化
  WKSDK.shared().channelManager.removeListener(channelInfoListener);
  // 取消监听cmd消息
  WKSDK.shared().chatManager.removeCMDListener(cmdListener);

  WKSDK.shared().connectManager.disconnect();
  store.state.imtoken = "";
  store.state.imuid = "";
  store.state.unread = 0;
  store.state.conversationWraps = [];
};

export { initIm, unInitIm, getConversations };
